export const INTAKE_PROFILE_IDS = [
  "medical_dermatology",
  "medical_dental",
  "medical_oriental",
  "medical_wellness",
  "beauty_hair",
  "beauty_makeup",
  "beauty_nail",
  "beauty_semipermanent",
  "beauty_personal_color",
  "beauty_esthetic",
  "beauty_other",
  "tour_day_tour",
  "tour_activity",
  "ticket_attraction_festival",
  "experience_class",
  "experience_photo_studio",
  "experience_hanbok_costume",
  "transport_airport_pickup",
  "transport_private_car",
  "telecom_esim_wifi",
  "telecom_living_support",
  "fnb_restaurant",
  "fnb_coupon",
  "commerce_retail_coupon",
  "commerce_shopping",
  "commerce_custom",
  "partner_misc",
] as const;

export const INTAKE_DOMAIN_IDS = ["medical", "beauty", "tour", "ticket", "experience", "transport", "telecom", "fnb", "commerce", "partner"] as const;

export const RESERVED_CATEGORY_GROUP_SLUGS = ["api", "auth", "assets", "invite"] as const;
export const RESERVED_CATEGORY_GROUP_SLUG_PREFIXES = ["admin"] as const;

export function categoryTaxonomyNodeId(profileId: string): string {
  return `category.${profileId}`;
}

export function defaultIntakeProfileSlug(profileId: string | undefined): string {
  if (!profileId) return "";
  const [, ...rest] = profileId.split("_");
  return (rest.length ? rest.join("-") : profileId.replace(/_/g, "-")).trim();
}

export function normalizeTaxonomySlug(value: string | undefined): string {
  if (!value) return "";
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9가-힣_-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function isReservedCategoryGroupSlug(slug: string): boolean {
  const normalized = normalizeTaxonomySlug(slug);
  return RESERVED_CATEGORY_GROUP_SLUGS.includes(normalized as (typeof RESERVED_CATEGORY_GROUP_SLUGS)[number]) || RESERVED_CATEGORY_GROUP_SLUG_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}

export function isKnownOrCustomIntakeProfileId(profileId: string): boolean {
  if ((INTAKE_PROFILE_IDS as readonly string[]).includes(profileId)) return true;
  const [domain] = profileId.split("_");
  return (INTAKE_DOMAIN_IDS as readonly string[]).includes(domain) && profileId.length > domain.length + 1;
}
